module.exports = __webpack_public_path__ + "media/title_pc_3.41eea02d.mp4";